import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { User } from '../../utils/backend-api/currentUser';
import { ArticleData } from '../Feed';
import { ArticleOrBriefing } from '../Feed/ArticleOrBriefingFeedItem';
import Layout from './Layout';

const queryClient = new QueryClient();

export interface ArticleContent {
  articles: ArticleOrBriefing[];
  contentData: ArticleData;
  commentCounts: { [key: number]: number };
  totalPages: number;
}
interface TopEntity {
  id: number;
  name: string;
  following: boolean;
}
type MatchingEntity = Omit<TopEntity, 'following'>;

export type SearchScope = 'articles' | 'directory' | 'forum';

export interface SearchPageProps {
  articleContent: ArticleContent;
  customBlurb?: string;
  followCount?: number;
  followers?: Array<User>;
  followStatus?: boolean;
  isSignedIn: boolean;
  matchingEntity?: MatchingEntity;
  page: number;
  query?: string;
  scope: SearchScope;
  title: string;
  topEntities?: Array<TopEntity>;
  topicOrAuthorLink?: string;
  topRelatedEntities: Array<string>;
}

const SearchPage = ({
  articleContent,
  customBlurb,
  followCount,
  followers,
  followStatus,
  isSignedIn,
  matchingEntity,
  page,
  query,
  scope,
  title,
  topEntities,
  topicOrAuthorLink,
  topRelatedEntities,
}: SearchPageProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Layout
        articleContent={articleContent}
        customBlurb={customBlurb}
        followCount={followCount}
        followers={followers}
        followStatus={followStatus}
        isSignedIn={isSignedIn}
        matchingEntity={matchingEntity}
        page={page}
        query={query}
        scope={scope}
        title={title}
        topEntities={topEntities}
        topicOrAuthorLink={topicOrAuthorLink}
        topRelatedEntities={topRelatedEntities}
      />
    </QueryClientProvider>
  );
};

export default SearchPage;
